import {Board} from './components/board/Board';
import React from 'react';
import './App.css';

function App () {
  return (
    <div className="App">
      <Board testID="Board"/>
    </div>
  );
}

export default App;
